export const Text = {
  baseStyle: {
    fontFamily: 'Nexa',
    // fontWeight: 300,
  },
};
